import '../scss/site.scss';
import "@coso/layout/external-dependencies";
import "@coso/layout/external-dependencies/jquery-validation";
import { ThemeManager } from "@coso/layout";
import { defineCustomElements as defineLayoutElements } from "@coso/layout/loader";
defineLayoutElements();

const themeVar = localStorage.getItem("theme");
if (themeVar == null) {
    localStorage.setItem("theme", "dark");
}

const layoutElement: HTMLCosoLayoutElement = document.querySelector('coso-layout');

layoutElement.addEventListener('componentLoaded',
    (event: any) => {
        const container = document.getElementById("site");
        const loadingElement = document.querySelector(".loading-progress");
        layoutElement.className = "visible";
        container.removeChild(loadingElement);
    });

layoutElement.isMvc = (window as any).isMvc;
layoutElement.isIdentityProvider = true;
layoutElement.isAuthenticated = (window as any).isAuthenticated;
layoutElement.identityProviderEndpoint = (window as any).identityProviderEndpoint;
layoutElement.shellEndpoint = (window as any).shellEndpoint;
layoutElement.dashboardEndpoint = (window as any).dashboardEndpoint;
layoutElement.menuLogoHref = "/";
layoutElement.tenantName = (window as any).tenantName;
layoutElement.userName = (window as any).userName;
layoutElement.supportsMultiTheme = false;
layoutElement.supportsTenantRename = (window as any).isSaaSAdmin;
layoutElement.dataCenterEU = (window as any).dataCenter == "ProductiveEU";
layoutElement.dataCenterUS = (window as any).dataCenter == "Productive";

const footerElement: HTMLCosoFooterElement = document.querySelector('coso-footer');
footerElement.contactUsLink = {
    href: "https://portal.connecting-software.com/support/create-case/?subjectid=" + (window as any).portalSubjectId + "&cs_deploymenttype=768880000&tenantid=" + (window as any).tenantId,
    target: "_blank"
};
footerElement.termsAndConditionsLink = {
    href: (window as any).portalEndpoint + "/support/SaaSServiceAgreement",
    target: "_blank"
};

footerElement.releaseNotesLink = { href: '/ReleaseNotes' };
footerElement.productVersion = "2.0.0";

ThemeManager.instance.theme$.subscribe((theme) => {
    const helperIframe = document.getElementById("helpSliderIframe") as HTMLIFrameElement;
    let serviceId = 0;
    if (helperIframe) {
        helperIframe.src = (window as any).shellEndpoint + "/HelpSlider?serviceId=" + serviceId + "&theme=" + theme;
    }
});